import { Service } from "./service"

export const ProductPriceListingService = Service


// WEBPACK FOOTER //
// ./src/state/listing/product-price/service/index.ts